import React from "react";
import { Link } from "react-router-dom";
import { LockOutlined, MailOutlined } from "@ant-design/icons";
import { Button, Form, Input, Flex } from "antd";
import { encode as base64_encode } from "base-64";
import { loginApi } from "../services/api";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch } from 'react-redux';
import { setUserAuth } from '../features/authSlice';

const FormItem = Form.Item;

const Login = () => {
  const [loginForm] = Form.useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onFinish = (values) => {
    const auth = "Basic " + base64_encode(values.email + ":" + values.password);
    loginApi(auth)
      .then((tokenData) => {
        localStorage.setItem(
          "token",
          tokenData.data.tokenType + " " + tokenData.data.accessToken
        );
        localStorage.setItem("userEmail", values.email);
        localStorage.setItem(
          "userGroups",
          JSON.stringify(tokenData.data.groups)
        );
        dispatch(setUserAuth({
          groups: tokenData.data.groups
        }));
      })
      .then(() => {
        navigate("/dashboard");
      })
      .catch((ex) => {
        Swal.fire({
          title: "Error!",
          text: "Login failed! Please check your email and password.",
          icon: "error",
        });
      });
  };

  const onFinishFailed = (errorInfo) => {};

  return (
    <>
       
    <Form
      form={loginForm}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
      style={{ gap: '8px' }}
    >
      <div style={{ marginBottom: "4px" }}>
        <label style={{ 
          color: "#08184F", 
          fontSize: "14px", 
          fontWeight: "500" 
        }}>
          Email Address
        </label>
      </div>
      <FormItem
        name="email"
        validateTrigger="onBlur"
        style={{ marginBottom: "12px" }}
        rules={[
          {
            required: true,
            message: "Please enter a vaild email address!",
          },
          {
            pattern:
              /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
            message: "Please enter a valid email address!",
          },
        ]}
      >
        <Input prefix={<MailOutlined />} placeholder="Email" />
      </FormItem>

      <div style={{ marginBottom: "4px" }}>
        <label style={{ 
          color: "#08184F", 
          fontSize: "14px", 
          fontWeight: "500" 
        }}>
          Password
        </label>
      </div>
      <FormItem
        name="password"
        validateTrigger="onBlur"
        style={{ marginBottom: "12px" }}
        rules={[
          {
            required: true,
            message: "Please enter a valid password!",
          },
          {
            pattern:
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[.,#@$!%*?&])[A-Za-z\d.,#@$!%*?&]{8,}$/i,
            message:
              "Password should contain at least 8 character with at least one of these symbols [.,#@$!%*?&], one uppercase, one lower case letter and a number",
          },
        ]}
      >
        <Input.Password
          prefix={<LockOutlined />}
          type="password"
          placeholder="Password"
        />
      </FormItem>
      <Flex justify="end" align="end">
          <Link
            to="/forgot-password"
            style={{ 
              color: '#08184F', 
              textDecoration: 'none',
              position: 'relative', 
              top: '-8px',
              fontWeight: "bold"
            }}
          >
            Forgot your password?
          </Link>
      </Flex>
      <FormItem>
        <Button
          style={{ 
            backgroundColor: "#0050b5",
            color: "#fff",
            width: "78px",
            height: "40px",
            borderRadius: "6px",
            border: "none",
            fontWeight: "bold"
          }}
          htmlType="submit"
          shape="default"
        >
          Sign in
        </Button>
      </FormItem>
  
    </Form>
    </>

  );
};

export default Login;
